module.exports = __webpack_public_path__ + "0.3e0e0ad3f2ce2d2830f4.worker.js"